<template>
  <div>
    <BaseTable
      id="mailqueuetable"
      :fields="fields"
      :items="mailqueue"
      hover
    />
  </div>
</template>
<script>
import BaseTable from './base/BaseTable.vue'

// $ql .= "  g_mailqueue.id ";
//     $ql .= "  ,g_groupmembers.groupmember_email ";
//     $ql .= "  ,g_surveymembers.groupsurveymember_survey_code ";
//     $ql .= "  ,g_mailqueue.scheduled_send_date ";
//     $ql .= "  ,g_mailqueue.scheduled_send_time ";
//     $ql .= "  ,g_mailqueuestatus.status_name ";
//     $ql .= "  ,g_mailqueue.sent_date ";

export default {
  components: {
    BaseTable
  },
  props: {
    surveyid: {
      type: String,
      default: '0'
    },
    changed: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'scheduled'
    }
  },
  data () {
    return {
      survey_id: this.$props.surveyid,
      anon: this.$store.state.anon || false,
      mailqueue: [],
      fields: [
        { key: 'id', label: 'Queue id', sortable: false, tdClass: 'w-2' },
        { key: 'mail_type', label: 'Mail type', sortable: true },
        { key: 'groupsurveymember_survey_code', sortable: true, label: 'Code' },
        { key: 'groupmember_email', sortable: true, label: 'Email', tdClass: `d-table-cell ${this.$store.state.anon || false ? 'g-anon' : ''}`, thClass: 'd-table-cell' },
        { key: 'scheduled_send_date', sortable: true, label: 'Scheduled Date' },
        { key: 'scheduled_send_time', sortable: true, label: 'Scheduled Time' },
        { key: 'status_name', sortable: true, label: 'Status' },
        { key: 'sent_date', sortable: true, label: 'Sent date' }
      ]
    }
  },
  computed: {
    reload: function () {
      return this.$store.state.surveymembers_reload
    }
  },
  watch: {
    changed: 'scheduledemails_get',
    reload: 'scheduledemails_get'
  },
  mounted () {
    this.scheduledemails_get()
  },
  methods: {
    scheduledemails_get () {
      console.log('Survey id: ', this.survey_id)
      const filter =
        this.$props.status === 'sent'
          ? {
              sent_status: {
                operator: 'IN',
                value: '2,3'
              }
            }
          : {
              sent_status: {
                operator: '<',
                value: '2'
              }
            }
      const survey_id = this.survey_id
      this.$store.dispatch('groupsurveymailqueue_fetch', { survey_id, filter })
        .then((resp) => {
          this.mailqueue = resp.data.result
        })
    }
  }

}
</script>
<style>
</style>
